import { makeStyles } from "@material-ui/core";
import { colors } from "../../../..";
const FTLTableRowStyles = makeStyles((theme) => ({
    root: ({ noCellBorder, type = "default", isFocusable, height = "auto", }) => {
        const styles = {
            position: "relative",
            display: "flex",
            height,
            pointerEvents: "auto",
            width: "100% !important",
        };
        if (type === "head")
            return Object.assign(Object.assign({}, styles), { backgroundColor: colors.bgPrimary, borderBottom: !noCellBorder ? `2px solid #ebedf0 !important` : "none", zIndex: 4, position: "sticky", top: 0 });
        else if (isFocusable)
            return Object.assign(Object.assign({}, styles), { "&:hover": {
                    backgroundColor: "#f5f9ff",
                }, "&:focus": {
                    outline: `2px ${theme.palette.border.focus}`,
                } });
        return Object.assign(Object.assign({}, styles), { borderBottom: !noCellBorder ? "1px solid #ebedf0" : "none", "&:last-child": {
                marginBottom: !noCellBorder ? "80px" : 0,
            }, boxSizing: "border-box" });
    },
}));
export default FTLTableRowStyles;
//# sourceMappingURL=FTLTableRowStyles.styles.js.map